module.exports = __webpack_public_path__ + "img/Streuselberg.786403c4.svg";